import React from 'react';
import './styles/scope.css';
import { ShakeProvider } from './ShakeProvider';
import ShakeEntrypoint from './components/ShakeEntrypoint';
import ShakeModal from './components/ShakeModal';

interface ShakeFeatureProps {
  projectId: string;
}

export default function ShakeFeature({ projectId }: ShakeFeatureProps) {
  return (
    <div className="shakeScope">
      <ShakeProvider projectId={projectId}>
        <ShakeEntrypoint />
        <ShakeModal />
      </ShakeProvider>
    </div>
  );
}
